module.exports = __webpack_public_path__ + "img/cnd-Connected.a3003cfc.svg";